<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="sms"/> SMS
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tabIndex">
          <b-tab :disabled="!['owner','admin', 'tech' , 'operationsManager', 'account', 'am'].includes($store.state.user.role)">
            <template #title>
              BrandName SMS
            </template>
          </b-tab>
          <b-tab :disabled="!['owner','admin', 'tech' , 'operationsManager', 'account', 'am'].includes($store.state.user.role)">
            <template #title>
              Gateway SMS
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('smsHistory') }}
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <s-m-s-brand-name-list v-if="tabIndex === 0"></s-m-s-brand-name-list>
    <s-m-s-gateway v-if="tabIndex === 1"></s-m-s-gateway>
    <s-m-s-history v-if="tabIndex === 2"></s-m-s-history>
  </main>
</template>

<script>


import SMSBrandNameList from "@/views/sms/SMSBrandNameList.vue";
import SMSGateway from "@/views/sms/SMSGateway.vue";
import SMSHistory from "@/views/sms/SMSHistory.vue";

export default {
  components: {SMSHistory, SMSGateway, SMSBrandNameList},
  data() {
    return {
      tabIndex: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        smsHistory: 'SMS history',
      },
      vi: {
        smsHistory: 'Lịch sử SMS',
      }
    }
  },
}
</script>